import React from 'react';
import parse from 'html-react-parser';
import { Photo } from '@project/API/resources/events';
import PhotoCarousel from '@project/components/PhotoCarousel';

export interface InfoEventsProps {
  description: string;
  dateStart: string;
  dateEnd: string;
  price: number;
  age: number;
  organizer: string;
  saleLink: string;
  photos: Array<Photo>;
  municipalDistrictTitle?: string;
}

export const InfoEvents: React.FC<InfoEventsProps> = ({
  description,
  dateEnd,
  dateStart,
  price,
  age,
  organizer,
  saleLink,
  photos,
  municipalDistrictTitle,
}) => {
  return (
    <div
      style={{
        overflowX: 'hidden',
      }}
    >
      {photos.length > 0 && (
        <PhotoCarousel items={photos} className={'img-carousel'} autoplay />
      )}
      {parse(description)}
      <p className={'news-info-row'}>
        <b>Цена: </b>
        {price === 0 ? 'Бесплатно' : price + 'р.'}
      </p>
      <p className={'news-info-row'}>
        <b>Ссылка для покупки билетов: </b>
        {saleLink ? (
          <a href={saleLink} target="_blank">
            {saleLink}
          </a>
        ) : (
          '-'
        )}
      </p>
      <p className={'news-info-row'}>
        <b>Возрастное ограничение: </b>
        <>{age + '+'}</>
      </p>
      <p className={'news-info-row'}>
        <b>Организатор: </b>

        {organizer || '-'}
      </p>
      <p className={'news-info-row'}>
        <b>Район: </b> {municipalDistrictTitle || '-'}
      </p>
      <p className={'news-info-row'}>
        <b>Дата начала: </b>

        {new Date(dateStart).toLocaleDateString()}
      </p>
      <p className={'news-info-row'}>
        <b>Дата окончания: </b>
        {new Date(dateEnd).toLocaleDateString()}
      </p>
    </div>
  );
};
